import React from 'react';

export default () => (
  <svg 
    focusable="false"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M14.375 0.5C14.5408 0.5 14.6997 0.565848 14.8169 0.683058L19.8169 5.68306C19.9342 5.80027 20 5.95924 20 6.125V14.875C20 15.0408 19.9342 15.1997 19.8169 15.3169L14.8169 20.3169C14.6997 20.4342 14.5408 20.5 14.375 20.5H5.625C5.45924 20.5 5.30027 20.4342 5.18306 20.3169L0.183058 15.3169C0.065848 15.1997 0 15.0408 0 14.875V6.125C0 5.95924 0.065848 5.80027 0.183058 5.68306L5.18306 0.683058C5.30027 0.565848 5.45924 0.5 5.625 0.5H14.375ZM9.88717 14.7714L9.79968 14.7667C9.358 14.7668 9 15.1249 9 15.5667C9 16.0085 9.35817 16.3667 9.8 16.3667C10.2418 16.3667 10.6 16.0085 10.6 15.5667C10.6 15.1543 10.288 14.8148 9.88717 14.7714ZM10.6 5.43333C10.6 5.06514 10.2418 4.76667 9.8 4.76667C9.35817 4.76667 9 5.06514 9 5.43333V12.1C9 12.4682 9.35817 12.7667 9.8 12.7667C10.2418 12.7667 10.6 12.4682 10.6 12.1V5.43333Z" />
  </svg>
);